import { Building2, Shield, AlertTriangle, Users, TrendingUp, Settings, ExternalLink } from "lucide-react";

const typeIconMap = {
  automation: Settings,
  governance: Shield,
  risk: AlertTriangle,
  "customer-experience": Users,
};

export const OrgPulseCard = ({ items, userProfile, onItemClick }) => {
  if (!items || items.length === 0) {
    return (
      <section className="card-surface p-6" data-testid="org-pulse-card-empty">
        <h3 className="text-title-lg font-headline text-[#F8FAFC] mb-4">
          {userProfile === "leader" ? "Organizational AI Pulse" : "Industry AI Updates"}
        </h3>
        <p className="text-[#94A3B8] text-sm">No updates available.</p>
      </section>
    );
  }

  return (
    <section className="card-surface p-6" data-testid="org-pulse-card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Building2 className="w-5 h-5 text-[#14B8A6]" />
          <h3 className="text-title-lg font-headline text-[#F8FAFC]">
            {userProfile === "leader" ? "Organizational AI Pulse" : "Industry AI Updates"}
          </h3>
        </div>
        <span className="text-xs text-[#94A3B8]">{items.length} updates</span>
      </div>

      <div className="space-y-3">
        {items.slice(0, 5).map((item, idx) => {
          const Icon = typeIconMap[item.update_type] || TrendingUp;
          return (
            <div 
              key={item.id || idx}
              onClick={() => onItemClick && onItemClick(item)}
              className="group p-4 rounded-xl bg-white/[0.02] hover:bg-white/[0.05] border border-white/[0.04] hover:border-white/[0.08] transition-all duration-200 cursor-pointer"
              data-testid={`org-pulse-item-${idx}`}
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-[#6D28D9]/10 text-[#A78BFA] flex items-center justify-center flex-shrink-0 group-hover:bg-[#6D28D9]/20 transition-colors">
                  <Icon className="w-4 h-4" />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    {item.org_name && (
                      <span className="text-xs font-medium text-[#14B8A6]">{item.org_name}</span>
                    )}
                    <span className="text-xs text-[#94A3B8] capitalize">{item.update_type}</span>
                  </div>

                  <h4 className="text-sm font-medium text-[#F8FAFC] group-hover:text-[#14B8A6] transition-colors mb-1 flex items-center gap-1">
                    {item.headline}
                    {item.source_url && <ExternalLink className="w-3 h-3 text-[#94A3B8]/40 group-hover:text-[#14B8A6] flex-shrink-0" />}
                  </h4>

                  <p className="text-xs text-[#94A3B8] line-clamp-2 mb-2">
                    {item.summary}
                  </p>

                  <div className="flex items-start gap-2 text-xs">
                    <svg className="w-3.5 h-3.5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                    </svg>
                    <span className="text-[#F8FAFC]/70">{item.why_it_matters}</span>
                  </div>

                  {userProfile === "leader" && item.strategic_implication && (
                    <div className="mt-3 p-2.5 rounded-lg bg-[#6D28D9]/[0.06] border-l-2 border-[#6D28D9]">
                      <p className="text-xs text-[#A78BFA] font-medium mb-1">Strategic Implication</p>
                      <p className="text-xs text-[#F8FAFC]/80">{item.strategic_implication}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
